import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 5 10", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.46875 1.01172L0.078125 1.38281C0 1.48047 0 1.63672 0.078125 1.71484L3.61328 5.25L0.078125 8.80469C0 8.88281 0 9.03906 0.078125 9.13672L0.46875 9.50781C0.566406 9.60547 0.703125 9.60547 0.800781 9.50781L4.90234 5.42578C4.98047 5.32812 4.98047 5.19141 4.90234 5.09375L0.800781 1.01172C0.703125 0.914062 0.566406 0.914062 0.46875 1.01172Z" }));
const ForwardRef = forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
